import request from '../../request';
// import faker from 'faker';

const moment = window.moment;


const activities = [];

const recursion = {
  options: [
    { name: 'Does not repeat', val: false, selected: true },
    { name: 'Repeats Weekly', val: 'weekly', selected: false },
    { name: 'Repeats Monthly', val: 'monthly', selected: false },
  ],
};

const weekdays = [
  { name: 'Sun', val: 0, selected: false },
  { name: 'Mon', val: 1, selected: false },
  { name: 'Tue', val: 2, selected: false },
  { name: 'Wed', val: 3, selected: false },
  { name: 'Thu', val: 4, selected: false },
  { name: 'Fri', val: 5, selected: false },
  { name: 'Sat', val: 6, selected: false },
];

const monthdays = () => {
  const days = [];
  for (let i = 1; i <= 31; i += 1) {
    days.push({ name: i, selected: false });
  }
  return days;
};

const colors = [
  'rgba(3, 169, 244, 0.15)', 'rgba(244, 67, 54, 0.15)', 'rgba(233, 30, 99, 0.15)',
  'rgba(156, 39, 176, 0.15)', 'rgba(63, 81, 181, 0.15)', 'rgba(0, 188, 212, 0.15)',
  'rgba(0, 150, 136, 0.15)', 'rgba(76, 175, 80, 0.15)', 'rgba(205, 220, 57, 0.15)',
  'rgba(255, 235, 59, 0.15)', 'rgba(255, 152, 0, 0.15)', 'rgba(121, 85, 72, 0.15)',
  'rgba(158, 158, 158, 0.15)', 'rgba(96, 125, 139, 0.15)'];

/*
for (let i = 0; i < 50; i++) {
  const backgroundColor = colors[i % 14];
  const startDate = faker.date.between('2017-01-01', '2017-01-31');
  const maxEndDate = new Date(startDate.getTime());
  maxEndDate.setDate(maxEndDate.getDate() + 2);
  const endDate = faker.date.between(startDate, maxEndDate);
  activities.push({
    id: i + 1,
    title: faker.lorem.words(3),
    start: startDate,
    end: endDate,
    backgroundColor,
    className: `event-${i + 1}`,
  });
}
*/


const CalendarState = {
  state: {
    loadedPeriod: {
      startDate: false,
      endDate: false,
    },
    form: {
      price: {
        name: 'price',
        value: 0,
        label: 'Price (€)',
        icon: '',
        errors: [],
      },
      youthPrice: {
        name: 'youth_price',
        value: '',
        label: 'Price (€)',
        icon: '',
        errors: [],
      },
      availability: {
        name: 'availability',
        value: 1,
        label: 'Availability',
        icon: '',
        errors: [],
      },
    },
    canceled: false,
    cancelJustification: '',
    errors: [],
    editOccurrence: false,
    initCalendar: false,
    updateCalendar: false,
    loadedId: undefined,
    activities,
    showCalendarEntry: false,
    showPopover: false,
    recursion,
    hasEndDate: false,
    endDate: undefined,
    selectedOccurrenceId: undefined,
    selectedRecurrenceId: undefined,
    selectedActivity: undefined,
    selectedDay: undefined,
    startTime: undefined,
    selectedRecursions: {
      monthdays: monthdays(),
      weekOfTheMonth: false,
      weekdays,
    },
    datesToReview: [],
  },
  mutations: {
    setCalendarCanceled(state, canceled) {
      if (!canceled) {
        Object.assign(state, { cancelJustification: '' });
      }
      Object.assign(state, { canceled });
    },
    resetSelectedActivity(state) {
      Object.assign(state, { selectedActivity: undefined });
    },
    resetEntry(state) {
      recursion.options.forEach((option) => {
        Object.assign(option, { selected: false });
      });
      weekdays.forEach((weekday) => {
        Object.assign(weekday, { selected: false });
      });
      Object.assign(state, {
        editOccurrence: false,
        recursion,
        hasEndDate: false,
        endDate: state.selectedDay,
        loadedId: undefined,
        // selectedActivity: undefined,
        selectedOccurrenceId: undefined,
        // selectedDay: undefined,
        startTime: undefined,
        selectedRecursions: {
          monthdays: monthdays(),
          weekOfTheMonth: false,
          weekdays,
        },
      });
      Object.assign(state, { errors: [] });
    },
    setCalendarCancelJustification(state, cancelJustification) {
      Object.assign(state, { cancelJustification });
    },
    setEntryActivity(state, payload) {
      if (typeof payload.occurrence !== 'undefined') {
        Object.assign(state, {
          editOccurrence: true,
          selectedDay: payload.occurrence.start.toDate(),
          startTime: payload.occurrence.start.format('HH:mm'),
          selectedOccurrenceId: payload.occurrence.id,
          selectedRecurrenceId: undefined,
        });
        Object.assign(state.form.availability, { value: payload.occurrence.availability });
        Object.assign(state.form.price, { value: payload.occurrence.price.toFixed(2) });
        let v = payload.occurrence.youthPrice;
        if (v !== null) {
          v = payload.occurrence.youthPrice.toFixed(2);
        }
        Object.assign(state.form.youthPrice, { value: v });
      }
      if (typeof payload.reccurrence !== 'undefined') {
        let isWeekly = false;
        if (payload.reccurrence.cron.type === 'weekly') {
          isWeekly = true;
        }
        if (typeof payload.reccurrence.cron.day_of_week[0] !== 'undefined') {
          if (payload.reccurrence.cron.day_of_week[0].indexOf('#') !== -1) {
            isWeekly = true;
            Object.assign(state.selectedRecursions,
              { weekOfTheMonth: payload.reccurrence.cron.day_of_week[0].slice(-1) });
          }
        }
        Object.assign(state, {
          editOccurrence: false,
          selectedActivity: payload.activity,
          selectedDay: moment(payload.reccurrence.cron.start_date).toDate(),
          selectedRecurrenceId: payload.recurrenceId,
          startTime: moment(payload.reccurrence.cron.start_date).format('HH:mm'),
        });
        Object.assign(state.form.availability, { value: payload.reccurrence.availability });
        Object.assign(state.form.price, { value: payload.reccurrence.price.toFixed(2) });

        let v = payload.reccurrence.youthPrice;
        if (v !== null) {
          v = payload.reccurrence.youthPrice.toFixed(2);
        }
        Object.assign(state.form.youthPrice, { value: v });

        if (payload.reccurrence.cron.end_date !== null) {
          Object.assign(state, { endDate: moment(payload.reccurrence.cron.end_date).toDate() });
          Object.assign(state, { hasEndDate: true });
        }
        state.recursion.options.forEach((option) => {
          if (option.val === payload.reccurrence.cron.type) {
            Object.assign(option, { selected: true });
          } else {
            Object.assign(option, { selected: false });
          }
          if (isWeekly && option.val === 'monthly') {
            Object.assign(option, { selected: false });
          }
          if (isWeekly && option.val === 'weekly') {
            Object.assign(option, { selected: true });
          }
        });
        if (payload.reccurrence.cron.type === 'monthly' && !isWeekly) {
          if (payload.reccurrence.cron.day_of_month[0] === '*') {
            state.selectedRecursions.monthdays.forEach((monthday) => {
              Object.assign(monthday, { selected: true });
            });
          } else {
            payload.reccurrence.cron.day_of_month.forEach((monthday) => {
              const selectedDay = state.selectedRecursions.monthdays.findIndex(stateMonthday =>
                parseInt(monthday, 10) === stateMonthday.name,
              );
              Object.assign(state.selectedRecursions.monthdays[selectedDay], { selected: true });
            });
          }
        }

        if (isWeekly) {
          if (payload.reccurrence.cron.day_of_week[0] === '*') {
            state.selectedRecursions.weekdays.forEach((weekday) => {
              Object.assign(weekday, { selected: true });
            });
          } else {
            payload.reccurrence.cron.day_of_week.forEach((weekday) => {
              const selectedDay = state.selectedRecursions.weekdays.findIndex(stateWeekday =>
                parseInt(weekday, 10) === stateWeekday.val,
              );
              Object.assign(state.selectedRecursions.weekdays[selectedDay], { selected: true });
            });
          }
        }
      }
    },
    setLoadedPeriod(state, payload) {
      Object.assign(state.loadedPeriod, { startDate: payload.startDate, endDate: payload.endDate });
    },
    setSelectedDay(state, payload) {
      Object.assign(state, { selectedDay: payload });
    },
    setStartTime(state, payload) {
      Object.assign(state, { startTime: payload });
    },
    setRecursionWeekOfMonth(state, payload) {
      Object.assign(state.selectedRecursions, { weekOfTheMonth: payload });
    },
    setWeekdays(state, payload) {
      for (let i = 0; i < 7; i += 1) {
        if (payload.indexOf(i) !== -1) {
          Object.assign(state.selectedRecursions.weekdays[i], { selected: true });
        } else {
          Object.assign(state.selectedRecursions.weekdays[i], { selected: false });
        }
      }
    },
    setMonthdays(state, payload) {
      for (let i = 0; i < 31; i += 1) {
        if (payload.indexOf(i) !== -1) {
          Object.assign(state.selectedRecursions.monthdays[i], { selected: true });
        } else {
          Object.assign(state.selectedRecursions.monthdays[i], { selected: false });
        }
      }
    },
    setMonthDaySelection(state, payload) {
      const newVal = !state.selectedRecursions.monthdays[payload].selected;
      Object.assign(state.selectedRecursions.monthdays[payload], { selected: newVal });
    },
    setHasEndDate(state, payload) {
      Object.assign(state, { hasEndDate: payload });
    },
    setCalendarEntryVisibility(state, payload) {
      Object.assign(state, { showCalendarEntry: payload });
      if (payload === false) {
        Object.assign(state, { selectedOccurrenceId: undefined });
        Object.assign(state, { selectedRecurrenceId: undefined });
      }
      Object.assign(state, { editOccurrence: false });
    },
    setCalendarPopoverVisibility(state, payload) {
      Object.assign(state, { showPopover: payload });
    },
    setCalendarSelectedActivity(state, payload) {
      Object.assign(state, { selectedActivity: payload });
    },
    setEndDate(state, payload) {
      Object.assign(state, { endDate: payload });
    },
    clearCalendar(state) {
      Object.assign(state, { initCalendar: false });
    },
    setUpdateCalendar(state, payload) {
      Object.assign(state, { updateCalendar: payload });
    },
    setActivityList(state, payload) {
      const newActivities = [];
      for (let i = 0; i < payload.activities.length; i += 1) {
        const backgroundColor = colors[payload.activities[i].activity_id % 14];
        const start = moment(payload.activities[i].date);
        const id = payload.activities[i].id;
        let reccurrenceId = payload.activities[i].calendar_id;
        if (typeof payload.activities[i].cron === 'undefined') {
          reccurrenceId = undefined;
        } else if (payload.activities[i].cron.type === '0') {
          reccurrenceId = undefined;
        }
        const activityId = payload.activities[i].activity_id;
        const title = payload.activities[i].locale[payload.language].name;
        const cron = payload.activities[i].cron;
        const dontUpdate = payload.activities[i].dont_update;
        const availability = payload.activities[i].availability;
        const currentAvailability = payload.activities[i].current_availability;
        const price = payload.activities[i].price;
        const youthPrice = payload.activities[i].youth_price;
        let className = `event-${i + 1}`;
        if (dontUpdate) {
          className += ' dontUpdate';
        }
        if (availability > currentAvailability) {
          className += ' hasBookings';
        }

        newActivities.push({
          id,
          backgroundColor,
          activityId,
          occurrenceId: id,
          reccurrenceId,
          cron,
          start,
          title,
          availability,
          price,
          youthPrice,
          dontUpdate,
          className,
        });
      }
      Object.assign(state, { activities: newActivities });
      Object.assign(state, { initCalendar: true });
    },
    setErrors(state, payload) {
      Object.assign(state, { errors: payload });
      if (typeof payload.availability !== 'undefined') {
        Object.assign(state.form.availability, { errors: payload.availability });
      }
      if (typeof payload.price !== 'undefined') {
        Object.assign(state.form.price, { errors: payload.price });
      }
    },
    setAvailability(state, payload) {
      Object.assign(state.form.availability, { value: parseInt(payload, 10) });
    },
    setPrice(state, payload) {
      Object.assign(state.form.price, { value: parseFloat(payload).toFixed(2) });
    },
    setYouthPrice(state, payload) {
      let v = null;
      if (payload !== null) {
        v = parseFloat(payload).toFixed(2);
      }
      if (payload === '') {
        v = 0;
      }
      Object.assign(state.form.youthPrice, { value: v });
    },
    setReviewDates(state, bookings) {
      const datesToReview = [];
      bookings.forEach((booking) => {
        if (booking.booking_state_id < 3) {
          if (datesToReview.indexOf(booking.date) === -1) {
            datesToReview.push(booking.date);
          }
        }
      });
      Object.assign(state, { datesToReview });
    },
  },
  actions: {
    setUpdateCalendar(context, payload) {
      context.commit('setUpdateCalendar', payload);
    },
    setCalendarSelectedDay(context, payload) {
      context.commit('setSelectedDay', payload);
    },
    setCalendarStartTime(context, payload) {
      context.commit('setStartTime', payload);
    },
    setCalendarWeekOfMonth(context, payload) {
      context.commit('setRecursionWeekOfMonth', payload);
    },
    toggleCalendarMonthdaySelection(context, payload) {
      context.commit('setMonthDaySelection', payload);
    },
    setCalendarHasEndDate(context, payload) {
      context.commit('setHasEndDate', payload);
    },
    setCalendarEntryVisibility(context, payload) {
      if (payload === true) {
        context.dispatch('setCalendarPopoverVisibility', false);
      }
      context.commit('setCalendarEntryVisibility', payload);
      context.commit('resetEntry');
    },
    setCalendarPopoverVisibility(context, payload) {
      if (payload === true) {
        context.dispatch('setCalendarEntryVisibility', false);
      }
      context.commit('setCalendarPopoverVisibility', payload);
    },
    setCalendarSelectedActivity(context, payload) {
      // http://localhost:8000/api/activity/eius-ea-quasi-cum-harum-delectus-qui-est-officiis
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity/${payload}`,
      }, (err, res) => {
        if (res !== 'undefined') {
          if (res.status === 200) {
            context.commit('setCalendarSelectedActivity', res.body.data);
          }
        }
      });
    },
    removeCalendarSelectedActivity(context) {
      context.commit('setCalendarSelectedActivity', undefined);
    },
    setCalendarWeekdays(context, payload) {
      context.commit('setWeekdays', payload); // Zero indexed
    },
    setCalendarMonthdays(context, payload) {
      context.commit('setMonthdays', payload); // Zero indexed
    },
    setCalendarEndDate(context, payload) {
      context.commit('setEndDate', payload);
    },
    clearCalendar(context) {
      context.commit('clearCalendar');
    },
    editCalendarOccurrence(context, payload) {
      context.commit('resetSelectedActivity');
      context.commit('clearCalendar');
      context.dispatch('setCalendarEntryVisibility', true);
      const selectedActivity = context.rootState.activity.list.filter(
        activity => activity.id === payload.activityId,
      )[0];
      const selectedOccurrence = context.state.activities.filter(
        activity => activity.occurrenceId === payload.occurrenceId,
      )[0];
      context.commit('setCalendarSelectedActivity', selectedActivity);
      context.commit('setEntryActivity', {
        activity: selectedActivity,
        occurrence: selectedOccurrence,
      });
    },
    editCalendarReccurrence(context, payload) {
      context.commit('resetSelectedActivity');
      context.commit('clearCalendar');
      context.dispatch('setCalendarEntryVisibility', true);
      const selectedActivity = context.rootState.activity.list.filter(
        activity => activity.id === payload.activityId,
      )[0];
      const selectedReccurrence = context.state.activities.filter(
        activity => activity.reccurrenceId === payload.reccurrenceId,
      )[0];
      context.commit('setEntryActivity', {
        activity: selectedActivity,
        reccurrence: selectedReccurrence,
        recurrenceId: selectedReccurrence.reccurrenceId,
      });
    },
    saveCalendarEntry(context) { // Saves and updates Reccurrences
      context.commit('setErrors', {});
      const selectedMonthDays = context.getters.calendarSelectedMonthDays;
      const selectedWeekDays = context.getters.calendarSelectedWeekDays;
      const selectedRecursion = context.getters.calendarSelectedRecursion;
      const recursionObject = {};
      recursionObject.availability = context.state.form.availability.value;
      recursionObject.price = parseFloat(context.state.form.price.value);
      recursionObject.youth_price = parseFloat(context.state.form.youthPrice.value);
      recursionObject.activity = context.state.selectedActivity;
      let startTime = '00:00';
      if (typeof context.state.startTime !== 'undefined') {
        // startTime = context.state.startTime.replace('h', ':').substring(0, 5);
        startTime = context.state.startTime;
      }
      recursionObject.start_date =
        `${moment(context.state.selectedDay).format('YYYY-MM-DD')} ${startTime}:00`;
      recursionObject.min = parseInt(startTime.split(':')[1], 10);
      recursionObject.hour = parseInt(startTime.split(':')[0], 10);
      recursionObject.day_of_week = ['*'];
      if (selectedRecursion) {
        recursionObject.recurrence = selectedRecursion;
        if (selectedRecursion === 'weekly'
          && context.state.selectedRecursions.weekOfTheMonth !== false) {
          recursionObject.recurrence = 'monthly';
          selectedWeekDays.forEach((weekday, index) => {
            selectedWeekDays[index] =
              `${weekday}#${context.state.selectedRecursions.weekOfTheMonth}`;
          });
          // recursionObject.week_of_month = context.state.selectedRecursions.weekOfTheMonth;
        }
      } else {
        recursionObject.recurrence = false;
      }
      if (selectedRecursion === false) {
        recursionObject.day_of_month = [context.state.selectedDay.getDate()];
        recursionObject.month = [context.state.selectedDay.getMonth() + 1];
        // recursionObject.year = [context.state.selectedDay.getFullYear()];
      } else {
        recursionObject.month = ['*'];
        recursionObject.day_of_month = ['*'];
      }
      if (selectedRecursion === 'weekly') {
        recursionObject.day_of_week = selectedWeekDays;
      } else if (selectedRecursion === 'monthly') {
        recursionObject.day_of_month = selectedMonthDays;
      }
      if (context.state.hasEndDate) {
        recursionObject.end_date =
          `${moment(context.state.endDate).format('YYYY-MM-DD')} 00:00:00`;
      }
      recursionObject.activity = context.state.selectedActivity.id;

      if (context.state.canceled) {
        recursionObject.canceled = true;
        recursionObject.justification = context.state.cancelJustification;
      }

      let requestType = 'POST';
      if (typeof context.state.selectedRecurrenceId !== 'undefined') {
        requestType = 'PUT';
        recursionObject.id = context.state.selectedRecurrenceId;
      }

      request.make({
        type: requestType,
        url: `${process.env.API_URL}activity_calendar`,
        data: recursionObject,
      }, (err, res) => {
        if (!err) {
          if (res.status === 204 || res.status === 200) {
            context.dispatch('showSaveSuccess');
            context.dispatch('setCalendarEntryVisibility', false);
            context.dispatch('getCalendarActivities');
            if (res.body !== null) {
              if (typeof res.body.data.bookings !== 'undefined') {
                if (res.body.data.bookings.length > 0) {
                  context.dispatch('setReviewDates', res.body.data.bookings);
                }
              }
            }
            context.commit('setErrors', []);
          }
        } else if (res.status === 422) {
          context.commit('setErrors', res.body.errors);
        }
      });
    },
    setReviewDates(context, bookings) {
      context.commit('setReviewDates', bookings);
    },
    updateCalendarOccurrence(context) {
      const requestType = 'PUT';

      const data = {
        id: context.state.selectedOccurrenceId,
        price: context.state.form.price.value,
        youth_price: context.state.form.youthPrice.value,
        availability: context.state.form.availability.value,
      };
      if (context.state.canceled) {
        data.canceled = true;
        data.justification = context.state.cancelJustification;
      }
      request.make({
        type: requestType,
        url: `${process.env.API_URL}activity_calendar_occurrence`,
        data,
      }, (err, res) => {
        if (res.status === 204) {
          context.dispatch('showSaveSuccess');
          context.dispatch('setCalendarEntryVisibility', false);
          context.dispatch('getCalendarActivities');
          context.commit('setCalendarCanceled', false);
        } else if (res.status === 422) {
          context.commit('setErrors', res.body.errors);
        }
      });
    },
    getCalendarActivities(context, payload) {
      context.dispatch('setUpdateCalendar', false);
      let startDate = context.state.loadedPeriod.startDate;
      let endDate = context.state.loadedPeriod.endDate;
      if (typeof payload !== 'undefined') {
        if (typeof payload[0] !== 'undefined') {
          startDate = moment(payload[0]).format('YYYY-MM-DD');
        }
        if (typeof payload[1] !== 'undefined') {
          endDate = moment(payload[1]).format('YYYY-MM-DD');
        }
      }
      context.commit('setLoadedPeriod', { startDate, endDate });

      const promoter = context.rootState.promoter.data.id;
      const data = {
        start_date: startDate,
        end_date: endDate,
        promoter,
      };
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity_calendar`,
        data,
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('setActivityList', {
            activities: res.body.data,
            language: context.rootState.language,
          });
          context.dispatch('setUpdateCalendar', true);
        } else if (res.status === 404) {
          context.commit('setActivityList', {
            activities: [],
            language: context.rootState.language,
          });
          context.dispatch('setUpdateCalendar', true);
        }
      });
    },
    resetCalendarEntry(context) {
      context.commit('resetEntry');
    },
    removeCalendarEvent(context) {
      request.make({
        type: 'DELETE',
        url: `${process.env.API_URL}activity_calendar/${context.state.selectedRecurrenceId}`,
      }, (err, res) => {
        if (res.status === 204) {
          context.dispatch('showSaveSuccess');
          context.dispatch('setCalendarEntryVisibility', false);
          context.dispatch('getCalendarActivities');
        }
      });
    },
    setCalendarAvailability(context, payload) {
      context.commit('setAvailability', payload);
    },
    setCalendarPrice(context, payload) {
      context.commit('setPrice', payload);
    },
    setCalendarYouthPrice(context, payload) {
      context.commit('setYouthPrice', payload);
    },
    cancelCalendarOccurrence(context) {
      context.commit('setCalendarCanceled', true);
      context.dispatch('updateCalendarOccurrence');
    },
  },
  getters: {
    calendarSelectedWeekName(state, getters) {
      let suffix = 'th';
      const selectedWeek = getters.calendarWeekOfMonth;
      if (typeof selectedWeek === 'undefined') {
        return false;
      } else if (selectedWeek === 1) {
        suffix = 'st';
      } else if (selectedWeek === 2) {
        suffix = 'nd';
      } else if (selectedWeek === 3) {
        suffix = 'rd';
      }
      return `${selectedWeek}${suffix}`;
    },
    calendarWeekOfMonth(state) {
      if (typeof state.selectedDay !== 'undefined') {
        const date = state.selectedDay;
        const exact = true;
        const month = date.getMonth();
        const year = date.getFullYear();
        const firstWeekday = new Date(year, month, 1).getDay();
        const lastDateOfMonth = new Date(year, month + 1, 0).getDate();
        const offsetDate = (date.getDate() + firstWeekday) - 1;
        const index = 1; // start index at 0 or 1, your choice;
        const weeksInMonth = index + Math.ceil(((lastDateOfMonth + firstWeekday) - 7) / 7);
        const week = index + Math.floor(offsetDate / 7);
        if (exact || week < 2 + index) return week;
        return week === weeksInMonth ? index + 5 : week;
      }
      return false;
    },
    calendarSelectedMonthDays(state) {
      const selectedDays =
        state.selectedRecursions.monthdays.filter(monthday => monthday.selected);
      return selectedDays.map(selectedDay => selectedDay.name);
    },
    calendarSelectedWeekDays(state) {
      const selectedDays =
        state.selectedRecursions.weekdays.filter(weekday => weekday.selected);
      return selectedDays.map(selectedDay => selectedDay.val);
    },
    calendarSelectedRecursion(state) {
      const selectedRecursions =
        state.recursion.options.filter(recursionOption => recursionOption.selected);
      const rec = selectedRecursions.map(selectedRecursion => selectedRecursion.val)[0];
      if (typeof rec === 'undefined') {
        return false;
      }
      return rec;
    },
    calendarSelectedRecursionIndex(state) {
      let index = 0;
      state.recursion.options.forEach((option, i) => {
        if (option.selected) index = i;
      });
      return index;
    },
  },
};


export default CalendarState;



// WEBPACK FOOTER //
// ./src/store/promoter/activitiesCalendar.js